import React from 'react'
import { strings } from '../../../localization/strings'
import { TextField } from '@material-ui/core/index'
import Button from '@material-ui/core/Button'
import { PhoneNumberFormat } from '../../../utils/formaters'
import { mailRegExp, phoneRegExp } from '../../../utils/regex'

class Component extends React.Component {
    initialState = {
        editing: false,
        name: '',
        mail: '',
        phoneNumber: '',
    }

    state = {
        ...this.initialState,
        ...this.props.initialValue,
    }

    submitOkData = () => {
        var { name, mail, phoneNumber } = { ...this.state }
        return { name, mail, phoneNumber }
    }

    render() {
        const { canOpen, errors } = this.props
        const { editing } = this.state
        const { name, mail, phoneNumber } = this.state
        const formatReq = (string) => (
            <div>
                {string}
                <span style={{ color: 'red' }}> *</span>
            </div>
        )
        let validationErrors = { mail: false, phoneNumber: false }
        if (!!mail && !mailRegExp.test(mail)) {
            validationErrors.mail = true
        }
        if (!!phoneNumber && !phoneRegExp.test(phoneNumber)) {
            validationErrors.phoneNumber = true
        }

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '50px 0px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        margin: '20px auto 10px auto',
                    }}
                >
                    {strings.warehouseContact_title}
                    <Button
                        color="primary"
                        size="small"
                        onClick={this.onEditClick}
                        disabled={!canOpen}
                    >
                        {strings.registrationAddressUpdateButton}
                    </Button>
                </div>

                {!editing ? (
                    !name && !mail && !phoneNumber ? (
                        <div style={{ fontSize: '80%', margin: 'auto' }}>
                            Si no se completan se tomarán los datos de registro
                        </div>
                    ) : !name || !mail || !phoneNumber ? (
                        <div
                            style={{
                                color: 'red',
                                fontSize: '80%',
                                margin: 'auto',
                            }}
                        >
                            Faltan completar datos obligatorios
                        </div>
                    ) : validationErrors.mail ||
                      validationErrors.phoneNumber ? (
                        <div
                            style={{
                                color: 'red',
                                fontSize: '80%',
                                margin: 'auto',
                            }}
                        >
                            Algunos datos estan incorrectos
                        </div>
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                marginTop: 10,
                            }}
                        >
                            <span
                                style={{ fontSize: '80%', padding: '10px 5px' }}
                            >
                                {strings.warehouseContact_name}: {name}
                            </span>
                            <span
                                style={{ fontSize: '80%', padding: '10px 5px' }}
                            >
                                {strings.warehouseContact_mail}: {mail}{' '}
                            </span>
                            <span
                                style={{ fontSize: '80%', padding: '10px 5px' }}
                            >
                                {strings.warehouseContact_phoneNumber}:{' '}
                                {phoneNumber}{' '}
                            </span>
                        </div>
                    )
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: 40,
                        }}
                    >
                        <TextField
                            label={formatReq(strings.warehouseContact_name)}
                            placeholder={
                                strings.warehouseContact_namePlaceholder
                            }
                            value={name}
                            error={errors.name}
                            onChange={(e) =>
                                this.setState({ name: e.target.value })
                            }
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                        />

                        <TextField
                            label={formatReq(strings.warehouseContact_mail)}
                            placeholder={
                                strings.warehouseContact_mailPlaceholder
                            }
                            value={mail}
                            error={errors.mail}
                            onChange={(e) =>
                                this.setState({ mail: e.target.value })
                            }
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                        />

                        <TextField
                            label={formatReq(
                                strings.warehouseContact_phoneNumber
                            )}
                            placeholder={
                                strings.warehouseContact_phoneNumberPlaceholder
                            }
                            value={phoneNumber}
                            error={errors.phoneNumber}
                            InputProps={{
                                inputComponent: PhoneNumberFormat,
                            }}
                            onChange={(e) =>
                                this.setState({ phoneNumber: e.target.value })
                            }
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                        />
                        <ul
                            style={{
                                color: 'red',
                                fontSize: 14,
                                display: errors.phoneNumber
                                    ? 'inherit'
                                    : 'none',
                                paddingLeft: '1em',
                                fontStyle: 'italic',
                            }}
                        >
                            <li>{strings.phoneNumberHint}</li>
                        </ul>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                marginTop: 20,
                            }}
                        >
                            <div style={{ flexGrow: 1 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitCancel}
                            >
                                {strings.dialogCancelLabel}
                            </Button>
                            <div style={{ width: 100 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitOk}
                            >
                                {strings.dialogOkLabel}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    submitOk = () => {
        var data = this.submitOkData()
        if (!data) return
        this.props.onChange(data)
        this.props.toggleOpen(false)
        this.clearState(data)
    }

    submitCancel = () => {
        this.props.toggleOpen(false)
        this.clearState(this.props.initialValue)
    }

    onEditClick = () => {
        this.setState({ editing: true })
        this.props.toggleOpen(true)
    }

    clearState = (data) => {
        this.setState({ ...this.initialState, ...data })
    }

    componentDidMount() {}
}

export default Component
